import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { ImportsModule } from "../../../../imports";
import { LoginBaseComponent } from "../login.base.component";
import { ReloginScreenComponent } from "../reloginscreen.component";

@Component({
    selector: 'app-login-stlucia',
    templateUrl: `login.stlucia.component.html`,
    styleUrls: ['./login.stlucia.component.scss'],
        imports: [FormsModule, RecaptchaModule, ImportsModule,ReloginScreenComponent],
})
export class LoginStluciaComponent extends LoginBaseComponent {


}